import { IMaintenanceSchedule } from "../../types/maintenanceSchedule.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
import { getCompanyId } from "./company.api";

const API_URL = `${import.meta.env.VITE_API_URL}/maintenance-schedule`;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function getPagedMaintenanceSchedule({
  status = [],
  search = "",
  startDueDateScheduleMaintenance = "",
  endDueDateScheduleMaintenance = "",
  page = 1,
  itemsPerPage = 10,
  orderBy = "",
  technicalConsultant = "",
  includeDeleted = false,
  fields = "companyId, renterName, renterPhone, renterVehicle, scheduledDate, scheduledTime, status, notes, createdAt, updatedAt, deletedAt, licensePlate, author, typeReview",
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });

  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  status && params.append("filters[status]", statusParam);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);
  startDueDateScheduleMaintenance &&
    params.append(
      "filters[startDueDateScheduleMaintenance]",
      startDueDateScheduleMaintenance.toString()
    );
  endDueDateScheduleMaintenance &&
    params.append(
      "filters[endDueDateScheduleMaintenance]",
      endDueDateScheduleMaintenance.toString()
    );
  technicalConsultant &&
    params.append("filters[technicalConsultant]", technicalConsultant);

  if (!includeDeleted) params.append("filters[deleteAt]", "null");

  const url = `${API_URL}/paged?${params.toString()}`;
  return (await makeRequestDebounced(url)) as ApiResponseType<
    IMaintenanceSchedule[]
  > & { totalItems: number; itemsPerPage: number };
}

export async function getMaintenanceScheduleSlots(
  date: string,
  typeReview: string
) {
  const params = new URLSearchParams();
  if (typeReview) params.append("typeReview", typeReview);

  const url = `${API_URL}/slots/${date}?${params.toString()}`;
  const options = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<{
      date: string;
      availableSlots: { time: string; available: number }[];
    }>
  >;
}

export async function createMaintenanceSchedule(
  maintenanceScheduleData: IMaintenanceSchedule
) {
  maintenanceScheduleData.companyId = getCompanyId();

  const url = `${API_URL}/create`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(maintenanceScheduleData),
  };

  return (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<IMaintenanceSchedule>
  >;
}

export async function updateMaintenanceSchedule(
  updatedData: IMaintenanceSchedule
) {
  const url = `${API_URL}/`;
  const options = {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(updatedData),
  };

  return (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<IMaintenanceSchedule>
  >;
}

export async function deleteMaintenanceSchedule(maintenanceScheduleId: string) {
  const url = `${API_URL}/${maintenanceScheduleId}`;
  const options = {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
  };
  return (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<IMaintenanceSchedule>
  >;
}
